import React, { createContext, useContext, useState } from "react";
import CustomBottomSheet from "../components/shared/cutomBottomSheet";

const BottomSheetContext = createContext();

export const BottomSheetProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState(null);

  const openSheet = (data) => {
    if (data.title) {
      console.log("title", data.title);
      setTitle(data.title);
    }else{
      setTitle(null);
    }
    setContent(data.content);
    setIsOpen(true);
  };

  const closeSheet = () => {
    setIsOpen(false);
  };

  return (
    <BottomSheetContext.Provider value={{ openSheet, closeSheet }}>
      {children}
      <CustomBottomSheet title={title} open={isOpen} onDismiss={closeSheet}>
        {content}
      </CustomBottomSheet>
    </BottomSheetContext.Provider>
  );
};

export const useBottomSheet = () => useContext(BottomSheetContext);
